import Vue from 'vue'

const BASE_URL = '/api/v3/albums';

const AlbumApi = {
  async update(albumId, params) {
    try {
      const response = await Vue.axios.put(`${BASE_URL}/${albumId}`, {
        album: params
      });

      if(response.status == 200 || response.status == 304) {
        return response.data.gallery;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e)
      return null;
    }
  },

  async addPhotos(albumId, params) {
    try {
      const response = await Vue.axios.post(`${BASE_URL}/${albumId}/add_photos`, {
        album: params
      });

      if(response.status == 200 || response.status == 304) {
        return response.data.photos;
      } else {
        return null;
      }
    } catch (e) {
      console.log(e)
      return null;
    }
  }
};

export default AlbumApi;